/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber0 = createReactComponent("outline", "number-0", "IconNumber0", [["path", { "d": "M16 16v-8", "key": "svg-0" }], ["path", { "d": "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z", "key": "svg-1" }]]);

export { IconNumber0 as default };
//# sourceMappingURL=IconNumber0.mjs.map
